module.exports = __webpack_public_path__ + "img/Basketball.78a54421.svg";